import { render } from "./DollSelector.vue?vue&type=template&id=5b4090ee&scoped=true"
import script from "./DollSelector.vue?vue&type=script&lang=js"
export * from "./DollSelector.vue?vue&type=script&lang=js"

import "./DollSelector.vue?vue&type=style&index=0&id=5b4090ee&lang=scss"
import "./DollSelector.vue?vue&type=style&index=1&id=5b4090ee&lang=css"
import "./DollSelector.vue?vue&type=style&index=2&id=5b4090ee&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b4090ee"]])

export default __exports__